import { ITypedAPITarget } from "network/NetworkStapler";
import { IPollingResponse, ISignData, ISigningInfo, ISigningResponse, SignMode } from "types/signing";

const SigningAPI = {
    getSign(signingInfo: ISigningInfo): ITypedAPITarget<ISignData> {
        return {
            url: "/ebv-authorization/rest/sign/" + signingInfo.signId,
            headers: {
                "Accept": "application/json"
            },
            parse: (json => {
                return json as ISignData;
            })
        };
    },

    postSign(authorizationType: SignMode, signingInfo: ISigningInfo, phoneId?: string): ITypedAPITarget<ISignData> {
        return {
            url: "/ebv-authorization/rest/sign/" + signingInfo.signId,
            method: "POST",
            body: phoneId ? {
                phoneId,
                authorizationType
            } : { authorizationType },
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            parse: (json => {
                return json as ISignData;
            })
        };
    },

    putSign(authorizationType: SignMode, signingInfo: ISigningInfo, oneTimePassword?: string): ITypedAPITarget<ISigningResponse> {
        return {
            url: "/ebv-authorization/rest/sign/" + signingInfo.signId,
            method: "PUT",
            body: {
                authorizationType,
                oneTimePassword
            },
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            parse: (json => {
                return json as ISigningResponse;
            })
        };
    },

    pollSid(url: string): ITypedAPITarget<IPollingResponse> {
        return {
            url: url,
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            parse: (json => {
                return json as IPollingResponse;
            })
        };
    }
};

export default SigningAPI;



// WEBPACK FOOTER //
// ./src/network/SigningAPI.ts